<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'EDMSCenter',
            to: {
              name: 'EDMSCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'EDMSCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增EDM</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增EDM -->
    <EDMSCreateEdit></EDMSCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import EDMSCreateEdit from '@/views/E-9__Edms/c/EDMSCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    EDMSCreateEdit,
  },
  computed: {
    ...mapState('edms', ['edms']),
  },
  created() {
    this.setEDMS({});
  },
  methods: {
    ...mapActions('edms', ['setEDMS', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'EDMSCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.edms.title) {
          this.errors.push('標題 required.');
        } else if (!this.edms.tab) {
          this.errors.push('Tab required.');
        } else if (!this.edms.published_at) {
          this.errors.push('發佈日 required.');
        } else if (!this.edms.cover_image) {
          this.errors.push('封面圖 required.');
        } else if (!this.edms.content) {
          this.errors.push('內容 required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.edms).then(() => {
          this.$router.push({ name: 'EDMSCenter' });
        });
      }
    },
  },
};
</script>

<style></style>
